module.exports = __webpack_public_path__ + "img/Tamas.3557b54d.png";